import React, { useState, useEffect } from 'react';
import { Table, Button, Typography, message } from 'antd';
import { DownloadOutlined, CheckOutlined } from '@ant-design/icons';
import api from '../../services/api';
import * as XLSX from 'xlsx';

const { Title } = Typography;

const Frequency = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchFrequencyData = async () => {
    setLoading(true);
    try {
      const response = await api.get('/organizer-frequency');
      setData(response.data);
    } catch (error) {
      message.error('Erro ao carregar dados de frequência');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchFrequencyData();
  }, []);

  const exportToExcel = () => {
    if (data.length === 0) {
      message.warning('Não há dados para exportar');
      return;
    }

    // Transformar dados para corresponder à tela
    const excelData = data.map(player => {
      const row = {
        'Jogador': `${player.playerName} (${player.frequency}%)`
      };
      
      // Adicionar cada jogo como coluna
      player.games.forEach(game => {
        row[game.date] = player.gameAttendance[game.id] ? '✓' : '';
      });
      
      return row;
    });

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Frequência');
    XLSX.writeFile(wb, 'frequencia_jogadores.xlsx');
    message.success('Arquivo exportado com sucesso!');
  };

  const columns = [
    {
      title: 'Jogador',
      dataIndex: 'playerName',
      key: 'playerName',
      fixed: 'left',
      width: 200,
      sorter: (a, b) => a.frequency - b.frequency,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => `${text} (${record.frequency}%)`
    },
    ...(data[0]?.games || []).map(game => ({
      title: game.date,
      dataIndex: ['gameAttendance', game.id],
      key: game.id,
      width: 100,
      align: 'center',
      render: (attended) => attended ? <CheckOutlined style={{ color: '#52c41a' }} /> : ''
    }))
  ];

  return (
    <div>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: 16,
        flexDirection: window.innerWidth <= 768 ? 'column' : 'row',
        gap: window.innerWidth <= 768 ? 12 : 0
      }}>
        <Title level={2} style={{ margin: 0 }}>Frequência dos últimos 60 jogos</Title>
        <Button 
          type="primary" 
          icon={<DownloadOutlined />} 
          onClick={exportToExcel}
          disabled={data.length === 0}
        >
          Exportar Excel
        </Button>
      </div>
      
      <Table
        columns={columns}
        dataSource={data}
        rowKey="playerId"
        loading={loading}
        pagination={false}
        scroll={{ x: 'max-content' }}
        size="small"
      />
    </div>
  );
};

export default Frequency;